import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Navbar, Footer } from "../components/Layout";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useText } from "../contexts/TextsContext";

export default function About() {
  const [c, setC] = useState(null);
  const t = useText();
  useEffect(() => {
    api.get("/site-content/about").then(r => setC(r.data.value)).catch(() => {});
  }, []);

  const a = c || {};
  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 md:px-8 py-16 md:py-24" data-testid="about-page">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FFC107] mb-4">— {a.kicker || "À propos"}</div>
            <h1 className="font-display font-black text-4xl md:text-6xl tracking-tight mb-8 leading-[0.95]">{a.title || "Immobilier d'activité, signé propriétaire."}</h1>
            <p className="text-lg text-slate-700 leading-relaxed mb-6">{a.intro}</p>
            <p className="text-base text-slate-600 leading-relaxed whitespace-pre-line">{a.content}</p>
          </div>
          <div className="lg:col-span-5">
            {a.image_url && (
              <div className="aspect-[4/5] overflow-hidden border border-slate-900/15">
                <img src={a.image_url} alt="" className="w-full h-full object-cover" />
              </div>
            )}
          </div>
        </div>

        {a.values?.length > 0 && (
          <div className="grid md:grid-cols-3 gap-6 mt-20">
            {a.values.map((v, i) => (
              <div key={i} className="bg-white border border-slate-900/15 p-8">
                <div className="w-10 h-10 bg-[#FFC107] border border-slate-900 flex items-center justify-center mb-4">
                  <Check className="w-5 h-5" strokeWidth={3} />
                </div>
                <div className="font-display font-bold text-xl mb-2">{v.title}</div>
                <p className="text-sm text-slate-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        )}

        <div className="mt-20 bg-slate-900 text-white p-10 md:p-16">
          <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight mb-4">{t("about.cta.title")}</h2>
          <p className="text-slate-300 max-w-2xl mb-8">{t("about.cta.desc")}</p>
          <Link to="/contact" data-testid="about-cta-contact" className="btn-brutal btn-brutal-solar inline-flex items-center gap-3 px-8 py-4 font-bold uppercase tracking-wider text-sm">
            {t("global.cta_contact_short")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
